import { z } from 'my-zod'
import { customerOrdersModel } from './customer-order-model'
import { customersModel } from '../customer/customers-model'
import { ReservationSchemas } from '../reservation'

export const customerOrderAdminView = customerOrdersModel.merge(ReservationSchemas.reservationModel).augment({
  customerShortId: customersModel.shape.shortId,
  customerFirstName: customersModel.shape.firstName,
  customerLastName: customersModel.shape.lastName,
  productName: z.string(),
  productShortId: z.string(),
  businessName: z.string(),
  canceledByEmail: z.string().nullable(),
  canceledByFullName: z.string().nullable()
})

export type customerOrderAdminView = z.infer<typeof customerOrderAdminView>
